export const TELEHEALTH_MEETING_LINK = `/api/teleui/join-session`;
export const MAX_LIMIT_AI_VOICE_EDIT_CHARACTERS = 100;
export const MAX_LIMIT_AI_VOICE_EDIT_WORDS = 100;
export const RECORD_EVENTS_SCHEDULED_TIME_SET = [
  10, 20, 40, 60, 120, 180, 300, 420, 560, 720, 900, 1100, 1320, 1560, 1820,
  2100, 2400, 2720, 3060, 3420, 3540,
];
export const TASK_STATUS = {
  QUEUED: "QUEUED",
  RUNNING: "RUNNING",
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  READY: "ready",
};
